"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var emotion_1 = require("emotion");
var js_brand_1 = require("@giphy/js-brand");
var adPillPosition = emotion_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    bottom: 5px;\n    left: 5px;\n    transition: opacity 0.33s ease-in-out;\n"], ["\n    position: absolute;\n    bottom: 5px;\n    left: 5px;\n    transition: opacity 0.33s ease-in-out;\n"])));
var adPillClass = emotion_1.cx(js_brand_1.adPill, adPillPosition);
var AdPill = function (_a) {
    var bottleData = _a.bottleData, isHovered = _a.isHovered;
    var renderAdPill = bottleData && Object.keys(bottleData).length > 0;
    return renderAdPill ? react_1.default.createElement("div", { className: adPillClass, style: { opacity: isHovered ? 0 : 1 } }) : null;
};
exports.default = AdPill;
var templateObject_1;
//# sourceMappingURL=ad-pill.js.map